export class TripPackageItemVO {
  constructor(totalAmount, currencyCode, tripAirItem, tripHotelItem) {
    this.totalAmount = totalAmount;
    this.currencyCode = currencyCode;
    this.tripAirItem = tripAirItem;
    this.tripHotelItem = tripHotelItem;
  }
}
